var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    fontWeight: _vm.fontWeight,
    fontSize: _vm.fontSize,
    textAlign: _vm.textAlign,
    margin: _vm.margin,
    color: _vm.color,
    fontStyle: _vm.fontStyle,
    fontFamily: _vm.fontFamily,
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }